import { c as _objectWithoutProperties, d as _objectSpread2 } from '../_helpers/_rollupPluginBabelHelpers.js';
import { createContext, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["id", "children"];
var PopupTargetContext = /*#__PURE__*/createContext(undefined);
var PopupTarget = /*#__PURE__*/forwardRef(function PopupTarget(_ref, ref) {
  var id = _ref.id,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var target = /*#__PURE__*/jsx("div", _objectSpread2(_objectSpread2({}, restProps), {}, {
    "data-portaltarget": id,
    ref: ref,
    children: typeof children !== 'function' && children
  }));
  return /*#__PURE__*/jsx(PopupTargetContext.Provider, {
    value: id,
    children: typeof children === 'function' ? children(target) : target
  });
});
PopupTarget.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
};

export { PopupTarget, PopupTargetContext };
